import React, { useState } from 'react';
import { LinearProgress } from '@mui/material';
import { SettingType } from '../../../../../api/vault/publishEndpoints';
import { IProps } from './interfaces';
import {
  SocialDialogWithPreviewPlayer,
  SocialDialogHeader,
  SocialDialogTitle,
  SocialDialogActions,
  WhatIsHappeningField, TitleField,
} from '../../../../Shared/Publish/SocialDialog';
import { ClipsPreviewPlayer } from '../../../../Shared';
import { SelectedClipsTotalDuration } from '../../../../Shared/SelectedClipsPreview';
import { DialogContentContainer } from '../../../../Shared/styles/dialog';
import { ProgressContainer } from '../../../../Shared/JobList/styles';

const TwitterPublishDialog: React.FunctionComponent<IProps> = (props: IProps) => {
  const {
    onPublish,
  } = props;

  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <SocialDialogWithPreviewPlayer settingType={SettingType.Twitter}>
      <SocialDialogHeader>
        <SocialDialogTitle />
        <SelectedClipsTotalDuration />
      </SocialDialogHeader>
      <ProgressContainer>
        {isProcessing && <LinearProgress />}
      </ProgressContainer>
      <DialogContentContainer>
        <TitleField />
        <WhatIsHappeningField />
        <ClipsPreviewPlayer />
      </DialogContentContainer>
      <SocialDialogActions onPublish={onPublish} setIsProcessing={setIsProcessing} isProcessing={isProcessing} fromClipper />
    </SocialDialogWithPreviewPlayer>
  );
};

export default TwitterPublishDialog;
